export default __webpack_public_path__ + "static/media/6AudiQ3.4db583b3.jpg";